import { ResourceTypes } from './ResourceTypes.js';

const MetricsSupportedTypes = [
  ResourceTypes.AnalysisServices,
  ResourceTypes.ApiManagementService,
  ResourceTypes.ApplicationGateways,
  ResourceTypes.ApplicationGatewayforContainers,
  ResourceTypes.ApplicationInsights,
  ResourceTypes.AppServiceEnvironments,
  ResourceTypes.AppServicePlans,
  ResourceTypes.AppServices,
  ResourceTypes.AutomationAccounts,
  ResourceTypes.AutonomousDatabases,
  ResourceTypes.AzureADDomainServices,
  ResourceTypes.AzureBotService,
  ResourceTypes.AzureDatabricks,
  ResourceTypes.AzureElasticSAN,
  ResourceTypes.AzureSpringCloud,
  ResourceTypes.AzureStackHCI,
  ResourceTypes.AzureVMWarePrivateClouds,
  ResourceTypes.BackupVaults,
  ResourceTypes.BareMetalMachine,
  ResourceTypes.Bastion,
  ResourceTypes.BatchAccounts,
  ResourceTypes.DataCollectionRules,
  ResourceTypes.BatchAi,
  ResourceTypes.CdnProfile,
  ResourceTypes.CdnWafPolicy,
  ResourceTypes.ClassicCloudServices,
  ResourceTypes.ClassicComputeVirtualMachines,
  ResourceTypes.CloudServiceExtendedSupport,
  ResourceTypes.CloudSimple,
  ResourceTypes.Cluster,
  ResourceTypes.ClusterManagers,
  ResourceTypes.CodeSigningAccounts,
  ResourceTypes.CognitiveServices,
  ResourceTypes.CommunicationsGateways,
  ResourceTypes.ConfigurationStores,
  ResourceTypes.Connections,
  ResourceTypes.ConnectedVehicle,
  ResourceTypes.ContainerAppsEnvironment,
  ResourceTypes.ContainerGroups,
  ResourceTypes.ContainerRegistries,
  ResourceTypes.ContainerServicesManaged,
  ResourceTypes.CosmosDB,
  ResourceTypes.CosmosCassandra,
  ResourceTypes.CosmosMongo,
  ResourceTypes.DataboxEdge,
  ResourceTypes.DataFactories,
  ResourceTypes.DataFactoriesv2,
  ResourceTypes.DataLakeAnalytics,
  ResourceTypes.DataLakeStore,
  ResourceTypes.DataShare,
  ResourceTypes.DBForMySql,
  ResourceTypes.DeviceProvisioningServices,
  ResourceTypes.DevCenters,
  ResourceTypes.Disks,
  ResourceTypes.DNSZones,
  ResourceTypes.DNSPrivateResolver,
  ResourceTypes.DNSForwardingRuleset,
  ResourceTypes.EnterpriseGraph,
  ResourceTypes.EventGridDomains,
  ResourceTypes.EventGridTopics,
  ResourceTypes.EventGridSystemTopics,
  ResourceTypes.EventHubs,
  ResourceTypes.EventHubsClusters,
  ResourceTypes.ExpressRouteCircuits,
  ResourceTypes.ExpressRoutePorts,
  ResourceTypes.Firewall,
  ResourceTypes.FrontDoor,
  ResourceTypes.HDInsights,
  ResourceTypes.IoTCentralApplications,
  ResourceTypes.IoTHub,
  ResourceTypes.IotSpaces,
  ResourceTypes.KeyVault,
  ResourceTypes.KubernetesArc,
  ResourceTypes.KustoClusters,
  ResourceTypes.Layer2IsolationDomain,
  ResourceTypes.Layer3IsolationDomain,
  ResourceTypes.LoadBalancers,
  ResourceTypes.LogAnalytics,
  ResourceTypes.LogicApps,
  ResourceTypes.LogicIntegrationServiceEnvironment,
  ResourceTypes.MachineLearningServiceWorkspace,
  ResourceTypes.ManagedNetworkFabricNetworkDevices,
  ResourceTypes.MariaDB,
  ResourceTypes.ManagedHsms,
  ResourceTypes.MediaServices,
  ResourceTypes.MonitorAccounts,
  ResourceTypes.MySQLFlexibleServers,
  ResourceTypes.NatGateway,
  ResourceTypes.NetAppCapacityPools,
  ResourceTypes.NetworkInterfaces,
  ResourceTypes.NGINXaaS,
  ResourceTypes.NotificationHubs,
  ResourceTypes.OracleExadataVMCluster,
  ResourceTypes.OracleExadbVMCluster,
  ResourceTypes.OrbitalL2Connections,
  ResourceTypes.MobileNetworkSite,
  ResourceTypes.RadioAccessNetwork,
  ResourceTypes.PacketCoreControlPlane,
  ResourceTypes.PacketCoreDataPlane,
  ResourceTypes.PeeringServices,
  ResourceTypes.PlayFabTitles,
  ResourceTypes.PostgreSQLServers,
  ResourceTypes.PostgreSQLServersV2,
  ResourceTypes.PowerBIDedicatedCapacities,
  ResourceTypes.PrivateEndpoint,
  ResourceTypes.PrivateLinkService,
  ResourceTypes.ProviderMonitorSettings,
  ResourceTypes.ProvisionedClusters,
  ResourceTypes.PublicIPAddresses,
  ResourceTypes.PublicIPPrefixes,
  ResourceTypes.RecoveryServicesVault,
  ResourceTypes.RedisCaches,
  ResourceTypes.RedisEnterprise,
  ResourceTypes.Relay,
  ResourceTypes.SearchServices,
  ResourceTypes.ServerGroups,
  ResourceTypes.ServiceBus,
  ResourceTypes.ServiceFabricMesh,
  ResourceTypes.SignalRService,
  ResourceTypes.SignalRServiceWebPubSub,
  ResourceTypes.Solutions,
  ResourceTypes.SqlManaged,
  ResourceTypes.SqlServersDatabases,
  ResourceTypes.SqlServersElasticPools,
  ResourceTypes.SqlServersElasticJobAgents,
  ResourceTypes.StaticSites,
  ResourceTypes.Storage,
  ResourceTypes.StorageAppliance,
  ResourceTypes.StorageCaches,
  ResourceTypes.StorageClassic,
  ResourceTypes.StorageMover,
  ResourceTypes.StorageSync,
  ResourceTypes.StreamAnalyticsJobs,
  ResourceTypes.SynapseWorkspace,
  ResourceTypes.TimeseriesInsightsEnvironments,
  ResourceTypes.TrafficManagerProfiles,
  ResourceTypes.VirtualMachines,
  ResourceTypes.VirtualMachinesScaleSets,
  ResourceTypes.VirtualNetworkGateWays,
  ResourceTypes.WebsitesSlots,
  ResourceTypes.AutoscaleSettings,
  ResourceTypes.AzureAD,
  ResourceTypes.AzsResourceMonitor,
  ResourceTypes.ConnectionMonitor,
  ResourceTypes.ContainerApps,
  ResourceTypes.CustomerInsights,
  ResourceTypes.ExpressRouteGateways,
  ResourceTypes.FabricLocations,
  ResourceTypes.NetworkVirtualAppliances,
  ResourceTypes.NetworkWatcher,
  ResourceTypes.PointToSiteVPN,
  ResourceTypes.PostgreSQLFlexibleServers,
  ResourceTypes.VPNGateways,
  ResourceTypes.VirtualHubs,
  ResourceTypes.WorkerPools,
  ResourceTypes.ManagedLustre,
  ResourceTypes.Grafana,
  ResourceTypes.ContactProfiles,
  ResourceTypes.Spacecrafts
];

export { MetricsSupportedTypes };
//# sourceMappingURL=MetricsResourceTypes.js.map
